import React, {useContext, useState, useEffect} from "react";
import {useLocation, withRouter} from "react-router-dom";
import { css } from "emotion";
import {boxStyles, colors, textSizes} from "../../styles/theme";
import TitleWithBackButton from "../TitleWithBackButton";
import {BuildContext} from "../../context/BuildSpotlightState";
import {GlobalContext} from "../../context/GlobalState";
import GenericButton from "../GenericButton";
import spotlights from "../../services/api/spotlights";

const UTMsBody = ({history}) => {
  const query = new URLSearchParams(useLocation().search);
  const {setCurrentSpotlight, utm_source, setUtmSource, utm_medium, setUtmMedium, utm_term, setUtmTerm, utm_content, setUtmContent, utm_campaign, setUtmCampaign} = useContext(BuildContext);
  const {currentSpotlight, setCurrentSpotlight: setGlobalSpotlight} = useContext(GlobalContext);
  const [isLoading, setIsLoading] = useState(false);
  const lastLocation = query.get('lastLocation');
  const backLocation = `targeting?lastLocation=${lastLocation}`;

  useEffect(() => {
    if (lastLocation === '/view') {
      setCurrentSpotlight(currentSpotlight);
    }
  }, []);


  const updateUtmSource = e => {
    const value = e.target.value;
    setUtmSource(value);
  };

  const updateUtmMedium = e => {
    const value = e.target.value;
    setUtmMedium(value);
  };

  const updateUtmCampaign = e => {
    const value = e.target.value;
    setUtmCampaign(value);
  };

  const updateUtmTerm = e => {
    const value = e.target.value;
    setUtmTerm(value);
  };

  const updateUtmContent = e => {
    const value = e.target.value;
    setUtmContent(value);
  };

  const handleSaveChanges = async () => {
    if (lastLocation === '/build') {
      history.push(`/${backLocation}`);
    } else {
      setIsLoading(true);
      const {data} = await spotlights.update({utm_source, utm_medium, utm_campaign, utm_term, utm_content, id: currentSpotlight.id});
      setGlobalSpotlight(data);
      history.push(`/${backLocation}`);
    }
  };

  return (
    <div className={container}>
      <div className="desktop">
        <TitleWithBackButton title="UTM Parameters" backLocation={backLocation} />
      </div>
      <div className="body">
        <form>
          <div className="form-row">
            <label>UTM Source</label>
            <input value={utm_source} onChange={updateUtmSource} placeholder='e.g. facebook, instagram, linkedin, reddit, etc.' />
          </div>
          <div className="form-row">
            <label>UTM Medium</label>
            <input value={utm_medium} onChange={updateUtmMedium} placeholder='e.g. social, organic, paid, email, affiliates, etc.' />
          </div>
          <div className="form-row">
            <label>UTM Campaign</label>
            <input value={utm_campaign} onChange={updateUtmCampaign} placeholder='e.g. coupon_FCGLL, black_friday, new_york_20, etc.' />
          </div>
          <div className="form-row">
            <label>UTM Term</label>
            <input value={utm_term} onChange={updateUtmTerm} placeholder='e.g. paid keywords (best_marketing_team, etc.)' />
          </div>
          <div className="form-row">
            <label>UTM Content</label>
            <input value={utm_content} onChange={updateUtmContent} placeholder='e.g. blue_button, top_bar, email_footer, etc.' />
          </div>

          <GenericButton
            text="SAVE CHANGES"
            handleClick={handleSaveChanges}
            disabled={isLoading}
            style={button}
          />
        </form>
      </div>
    </div>
  );
};

export default withRouter(UTMsBody);

const container = css`
  height: 100%;
  display: flex;
  flex-direction: column;
  
  .desktop {
    display: none;
  }
  
  .body {
    display: flex;
    justify-content: center;
    padding: 10px;
    margin-top: 15px;
    
    form {
      max-width: 600px;
      width: 100%;
    }
  }
  
  .form-row {
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
  }
  
  label {
    font-size: 12px;
    color: #191919;
    padding-bottom: 10px;
    font-weight: 500;
    letter-spacing: 1px;
  }
  
  input {
    background-color: ${colors.inputBackground};
    border: none;
    border-radius: 8px;
    padding: ${boxStyles.standardPadding};
    color: ${colors.inputTextColor};
    flex: 1;
    font-size: ${textSizes.normal};
    margin-bottom: 15px;

    &::placeholder {
      color: ${colors.placeholderText};
    }
  }
  
  @media screen and (min-width: ${boxStyles.desktopBreak}) {
    .desktop {
      display: initial;
    }
    
    .body {
      padding: 30px;
    }
  }
`;

const button = css`
  width: auto;
  min-width: 180px;
  padding-left: 20px;
  padding-right 20px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 30px;
`;
